import styled from 'styled-components';

import { media } from 'helpers/breakpoints';
import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';
import { Title } from 'components/Toolkit/InfoTitle/Title/Title';
import { MetaListItem } from 'components/Toolkit/InfoTitle/MetaListItem/MetaListItem';
import { Link } from 'components/Toolkit/Button/Link';

export interface ContentLinkProps {
  image: string;
  title: string;
  subtext: string;
  linkText: string;
  link: string;
}

const Container = styled.div`
  max-width: 100%;
`;

const CardWrapper = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};
  overflow: hidden;
  height: 100%;
`;

const ImageContainer = styled.div`
  position: relative;
`;

const Picture = styled.picture`
  img {
    border-radius: ${({ theme }) =>
      `${theme.borderRadius.default} 0 0 ${theme.borderRadius.default}`};
    width: 100%;
    height: auto;
    aspect-ratio: attr(width) / attr(height);
  }
`;

const MainContent = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.GREY_DARKER};
`;

const Body = styled.div`
  background: ${({ theme }) => theme.colors.WHITE};
  padding: ${({ theme }) => theme.spacing.S4};
  display: flex;
  flex-direction: column;
  align-items: start;

  ${media.large} {
    padding: ${({ theme }) => theme.spacing.S8};
  }
`;

const SInfoTitle = styled(InfoTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  ${Title} {
    ${({ theme }) => theme.fontSize.B12};
    font-weight: ${({ theme }) => theme.fontWeight.bold};

    ${media.large} {
      ${({ theme }) => theme.fontSize.L18};
    }
  }

  ${MetaListItem} {
    ${({ theme }) => theme.fontSize.B12};
    font-weight: ${({ theme }) => theme.fontWeight.regular};

    ${media.large} {
      ${({ theme }) => theme.fontSize.M14};
    }
  }
`;

const SLink = styled(Link)`
  ${({ theme }) => theme.fontSize.B12};
  color: ${({ theme }) => theme.colors.BLUE};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  margin-bottom: ${({ theme }) => theme.spacing.S8};
  text-transform: capitalize;

  ${media.large} {
    ${({ theme }) => theme.fontSize.M14};
  }
`;

function ContentLink({
  image,
  title,
  subtext,
  linkText,
  link,
}: ContentLinkProps) {
  return (
    <Container>
      <CardWrapper>
        <ImageContainer>
          <Picture>
            <img src={image} alt={title} width="600" height="450" />
          </Picture>
        </ImageContainer>
        <MainContent>
          <Body>
            <SInfoTitle
              title={title || ''}
              listItems={[subtext || '']}
              variant="SMALL"
            />
            {linkText && (
              <SLink href={link} target="_blank">
                {linkText}
              </SLink>
            )}
          </Body>
        </MainContent>
      </CardWrapper>
    </Container>
  );
}

export { ContentLink };
